// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Rm-z","badgeLink":"Sm-z","category":"Tm-z"};